export function setLocalStorageObject(key: string, value: Record<string, unknown>): void {
    if(typeof localStorage === 'undefined') {
        throw new Error('localStorage is not available');
    }

    localStorage.setItem(key, JSON.stringify(value));
}

export function getLocalStorageObject(key: string, defaultValue: Record<string, unknown>): Record<string, unknown> {
    if(typeof localStorage === 'undefined') {
        throw new Error('localStorage is not available');
    }

    const value = localStorage.getItem(key);
    if(value === null) {
        return defaultValue;
    }
    return JSON.parse(value);
}

export function setSessionStorageObject(key: string, value: Record<string, unknown>): void {
    if(typeof sessionStorage === 'undefined') {
        throw new Error('sessionStorage is not available');
    }

    sessionStorage.setItem(key, JSON.stringify(value));
}

export function getSessionStorageObject(key: string, defaultValue: Record<string, unknown>): Record<string, unknown> {
    if(typeof sessionStorage === 'undefined') {
        throw new Error('sessionStorage is not available');
    }

    const value = sessionStorage.getItem(key);
    if(value === null) {
        return defaultValue;
    }
    return JSON.parse(value);
}